import { VSelect, VAutocomplete } from 'vuetify/lib'
import { BASE } from '@/config'

export default {
  name: 'Select',
  props: [
    'no-data-text',
    'label',
    'items',
    'item-value',
    'item-text',
    'blank-item',
    'blank-text',
    'blank-value',
    'blank',
    'dense',
    'flat',
    'value',
    'required',
    'rules',
    'disabled'
  ],
  methods: {
    getItemsWithBlankItemValue() {
      const items = this.$props.items

      if (items.length) {
        if (typeof this.$props.blankItem === 'object') {
          return [this.$props.blankItem, ...items]
        } else {
          const blankText = this.$props.blankText || 'Все'
          if (typeof items[0] === 'object') {
            const blankValue = this.$props.blankValue || null
            const textProperty = this.$props.itemText || 'text'
            const valueProperty = this.$props.itemValue || 'value'
            
            return [
              { [textProperty]: blankText, [valueProperty]: blankValue },
              ...items
            ]
          } else {
            return [blankText, ...items]
          }
        }
      }
      return items
    }
  },
  render(h) {
    const component = this.$props.items.length >= BASE.ITEMS_LENGHT_FOR_AUTOROMPLETE ? VAutocomplete : VSelect
    return h(component, {
      props: {
        ...this.$props,
        noDataText: 'Данных нет' || this.$props.noDataText,
        items: typeof this.$props.blank !== 'undefined' ?
                  this.getItemsWithBlankItemValue() :
                  this.$props.items
      },
      scopedSlots: { ...this.$scopedSlots },
      on: { ...this.$listeners },
    })
  }
}
